export const dataProfile = [
  {
    label: "Nama Lengkap",
    name: "name",
    type: "text",
    placeholder: "Masukkan nama lengkap",
  },
  {
    label: "Email",
    name: "email",
    type: "email",
    placeholder: "Masukkan email",
  },
  {
    label: "Nomor Telepon",
    name: "phone",
    type: "tel",
    placeholder: "Masukkan nomor telepon",
  },
];
